import styled from "styled-components";
import { Callout } from "../styles/typography";

const Card = styled.button`
  all: unset;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  border-radius: 20px;
  background: rgb(${(props) => props.theme.colors.white});
  border: 2px solid
    rgb(
      ${(props) =>
        props.$selected
          ? props.theme.colors.blue600
          : props.theme.colors.neutral150}
    );
`;

const ImageFrame = styled.div`
  box-sizing: border-box;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  background-size: cover;
  background-repeat: no-repeat;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    backdrop-filter: blur(8px);
  }
`;

const PlaceholderLabel = styled(Callout)`
  color: rgb(${(props) => props.theme.colors.neutral200});
  text-align: center;
  padding: 0 8px;
`;

const CaptionRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 12px;
`;

const Label = styled(Callout)`
  color: rgb(
    ${(props) =>
      props.$selected
        ? props.theme.colors.blue600
        : props.theme.colors.neutral600}
  );
  margin-right: auto;
`;

const DescriptionText = styled(Callout)`
  color: rgb(${(props) => props.theme.colors.neutral400});
  margin-right: auto;
`;

/**
 * @param {{
 *  id:string,
 *  label:string,
 *  description?:string,
 *  imageUrl?:string,
 *  code?:string,
 *  selected:boolean,
 *  onSelect:(id:string)=>void,
 *  showBgImage?:boolean
 * }} props
 */
const OptionCard = ({
  id,
  label,
  description,
  imageUrl,
  selected,
  onSelect,
  showBgImage,
  style,
}) => {
  return (
    <Card
      type="button"
      style={style}
      $selected={selected}
      aria-pressed={selected}
      onClick={() => onSelect(id)}
    >
      <ImageFrame
        style={{
          backgroundImage:
            imageUrl && showBgImage ? `url(${imageUrl})` : "none",
          backgroundColor: !showBgImage ? `rgba(240, 237, 231, 1)` : "",
        }}
      >
        {imageUrl ? (
          <img src={imageUrl} alt={label} />
        ) : (
          <PlaceholderLabel>{label}</PlaceholderLabel>
        )}
      </ImageFrame>
      {(label || description) && (
        <CaptionRow>
          {label && (
            <Label data-label={label} $selected={selected}>
              {label}
            </Label>
          )}
          {description && <DescriptionText>{description}</DescriptionText>}
        </CaptionRow>
      )}
    </Card>
  );
};

export default OptionCard;
